// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"227":"03babc40","315":"df511642","816":"df511642","845":"03babc40","974":"df511642"}[chunkId] + ".chunk.css";
};